import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, FormGroupDirective, ValidationErrors } from '@angular/forms';
import { FormConfigService } from 'src/app/form-config/form-config.service';
import { DropDownOption } from '../../model/interfaces/drop-down-option.interface';
import { TASK_STATUS_ITEMS } from './product-notes.consts';
import { isNullOrUndefined } from '@swimlane/ngx-datatable';
import { ProductCaptureGroupsEnum, ProductNotesEnum } from '../../model/enums/product-capture.enums';

@Component({
  selector: 'app-product-notes',
  templateUrl: './product-notes.component.html',
  styleUrls: ['./product-notes.component.scss'],
})
export class ProductNotesComponent implements OnInit {
  @Input() formGroupName: string;
  @Input() formName: string;
  @Input() productId: string;
  @Input() canUserEdit = true;

  taskStatusItems: DropDownOption[] = TASK_STATUS_ITEMS;

  form: FormGroup;
  labels: Record<string, any>;

  constructor(
    private formConfigService: FormConfigService,
    private rootFormGroup: FormGroupDirective,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.labels = this.formConfigService.getLabels();
    this.form = this.rootFormGroup.control.get(this.formGroupName) as FormGroup;
    this.tasks.addValidators(this.validateTasks.bind(this));
  }

  addTask(): void {
    this.tasks.push(this.fb.group({
      description: [],
      status: [],
      dueDate: [],
    }));
  }

  deleteTask(index: number): void {
    this.tasks.removeAt(index);
    if (!this.tasks.length) {
      this.addTask();
    }
  }

  get notesAndTasks(): FormGroup {
    return this.rootFormGroup.control.get(ProductCaptureGroupsEnum.notesAndTasks) as FormGroup;
  }

  get tasks(): FormArray {
    return this.notesAndTasks.get(ProductNotesEnum.tasks) as FormArray;
  }

  validateTasks(): ValidationErrors | null {
    if (!this.tasks.length || this.tasks.length === 1) {
      if (this.tasks.length === 1) {
        this.tasks.controls[0].setErrors(null);
        Object.keys(this.tasks.controls[0].value).forEach((key) => {
          this.tasks.controls[0].get(key).setErrors(null);
        });
      }
      return null;
    }

    let hasInvalidFields = false;
    if (this.tasks.length > 1) {
      this.tasks.controls.forEach((control) => {
        control.setErrors(null);

        Object.keys(control.value).forEach((key) => {
          control.get(key).setErrors(null);

          if (isNullOrUndefined(control.value[key])) {
            control.get(key).setErrors({ required: true });
            hasInvalidFields = true;
          }
         });
      });
    }

    return hasInvalidFields ? { required: true } : null;
  }

}
